import { useMutation, UseMutationOptions } from 'react-query';
import { toast } from 'sonner';

import type { MatchDocumentsByFilenameResponseDto } from '../../../../backend/src/matter/doc/dto/match-documents-by-filename.dto.js';
import { APIBaseChronos } from '@/api/hosts';
import useGetFetchConfig, { FetchMethod } from '@/api/useGetFetchConfig';

interface MatchDocumentsByFilenameParams {
  matterId: string;
  filenames: string[];
  matchBy?: 'filename' | 'controlNumber';
  ignoreFileExtensions?: boolean;
}

export const useMatchDocumentsByFilename = (
  options?: UseMutationOptions<MatchDocumentsByFilenameResponseDto, Error, MatchDocumentsByFilenameParams>,
) => {
  const { getFetchConfig } = useGetFetchConfig();

  return useMutation({
    mutationFn: async ({ matterId, filenames, matchBy, ignoreFileExtensions }: MatchDocumentsByFilenameParams) => {
      const response = await fetch(
        `${APIBaseChronos}/api/matter/${matterId}/docs/match-by-filename`,
        getFetchConfig({
          method: FetchMethod.POST,
          data: { filenames, matchBy, ignoreFileExtensions },
        }),
      );

      if (!response.ok) {
        throw new Error('Failed to match documents');
      }

      return response.json();
    },
    onError: () => {
      toast.error('Something went wrong trying to find those documents. Please try again.');
    },
    ...options,
  });
};
